import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify"
import customAPI from "../api/customAPI.js"
import { apiRoute, stateEnum } from "../constants/enum";
const { item } = stateEnum

let initialState = {
    detail: [],
    isNewEntry: false
}


export const setItemDetail = createAsyncThunk("getitemdetail",
    async ({ itemcode, token ,db_user}) => {
        try {
            
            const { data } = await customAPI.post(
                apiRoute.item.fetch,
                {
                    item_code: itemcode,
                    group_code: '',
                    made: '',
                    category: '',
                    db_user:db_user
                },
                {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            )
            return data.data
        }
        catch (error) {
            toast.error("Data not found", {
                position: "top-center"
            })
            console.log(error)
        }
    }
)

const itemSlice = createSlice({
    name: item,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;

        },
        resetDetail: (state) => {
            state.detail = []
            state.isNewEntry = true

        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setItemDetail.fulfilled, (state, action) => {
                state.detail = action.payload;
            })
            .addCase(setItemDetail.rejected, (state) => {
                state.detail = []
            })
    }
})
export const { setNewEntryMode, resetDetail } = itemSlice.actions
export default itemSlice.reducer